export default {
  setProgramUIState: (state, value) => state.programUIState = value,
  setEvents: (state, events) => state.events = events
}